import { useLoggedInUser } from './logged-in-user';

export function useRBAC() {
  const { data: userData } = useLoggedInUser();

  // useCan returns true if the user can perform "action" on "resource".
  const userCan = (resource, action) => {
    const policies = userData?.policies ?? [];

    for (let i = 0; i < policies.length; i++) {
      const polResource = policies[i]?.resource ?? '';
      const polAction = policies[i]?.action ?? '';

      if (polResource === resource && polAction === action) {
        return true;
      }
    }

    return false;
  };

  // userHas returns true if the user has a specific role.
  const userHas = (...roleCode) => {
    if (Array.isArray(roleCode) === false || roleCode.length === 0) {
      return false;
    }

    const userRole = userData?.role?.code ?? '';

    for (let i = 0; i < roleCode.length; i++) {
      if (userRole === roleCode[i]) {
        return true;
      }
    }

    return false;
  };

  const userBanned = () => {
    const isBanned = Boolean(userData?.bannedIP ?? false);
    return isBanned;
  }

  return {
    userCan,
    userHas,
    userBanned
  };
}
